import Client from './Client'
import { Error } from './Error'

export default class Mission extends Client {
  async fetchMissions(token, payload) {
    try {
      const query =  {
        find: payload.search,
        state: payload.state,
        created_at: payload.range,
        offset: payload.offset,
        limit: payload.limit,
        type: 'issuedall'
      }
      return await this.request(token, 'get', 'mission', null, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async createMission(token, payload) {
    try {
      return await this.request(token, 'post', 'mission', {...payload, send_email: true }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async editMission(token, payload, id) {
    try {
      return await this.request(token, 'post', `mission/${id}`, payload, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteMission(token, id) {
    try {
      return await this.request(token, 'delete', `mission/${id}`, {}, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
